import api from "./Api";

class CompraService {
  GetCompra(payload) {
    return api.get("/v1/compra/" + payload).then((response) => {
      return response.data;
    });
  }

  PostCompra(payload) {
    return api.post("/v1/compra/", payload).then((response) => {
      return response.data;
    });
  }

  PutCompra(payload) {
    return api.put("/v1/compra/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteCompra(payload) {
    return api.delete("/v1/compra/" + payload).then((response) => {
      return response.data;
    });
  }

  GetCompraOData(payload) {
    return api.get("/OData/compra" + payload).then((response) => {
      return response.data;
    });
  }

  ImportarXML(payload) {
    return api.get("/v1/compra/ImportarXML" + payload).then((response) => {
      return response.data;
    });
  }

  Upload(payload) {
    const formData = new FormData();
    formData.append("arquivo", payload);
    return api
      .post("/v1/compra/Upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        return response.data;
      });
  }

  GetRelatorio(payload) {
    return api.post("/v1/compra/GetRelatorio", payload).then((response) => {
      return response.data;
    });
  }

  ConfirmarImportacao(payload) {
    return api
      .put("/v1/compra/ConfirmarImportacao", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new CompraService();
